import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import logger from "redux-logger";
import * as Sentry from "@sentry/react";
import { multiboxReducer } from "./multibox/reducers";
import { sessionReducer } from "./session/reducers";

const rootReducer = combineReducers({
  multibox: multiboxReducer,
  session: sessionReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const middleware = process.env.NODE_ENV === "production" ? [] : [logger];

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Optionally pass options
});

export const store = createStore(
  rootReducer,
  compose(applyMiddleware(...middleware), sentryReduxEnhancer)
);
